import {
  Box,
  Flex,
  Grid,
  Icon,
  PlacementWithLogical,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react'
import ShieldIcon from '@/public/assets/icons/shield.svg'
import InfoIcon from '@/public/assets/icons/info.svg'
import { useTranslation } from 'next-i18next/pages'

export const RoundNumber = ({
  roundNumber,
  date,
  placement = 'top-end',
}: {
  roundNumber: number
  date: string
  placement?: PlacementWithLogical
}) => {
  const { t } = useTranslation()
  return (
    <Popover flip={false} placement={placement}>
      <PopoverTrigger>
        <Flex
          rounded={'xl'}
          py={2}
          px={3}
          bg={'#68F27612'}
          border={'1px solid'}
          borderColor={'#68F27624'}
          alignItems={'center'}
          gap={2}
          cursor={'pointer'}
        >
          <ShieldIcon />
          <Text display={{ base: 'none', lg: 'block' }} fontSize={'sm'} fontWeight={700}>
            #{roundNumber}
          </Text>
          <Flex
            display={{ base: 'none', lg: 'flex' }}
            bg={'whiteAlpha.100'}
            flexShrink={0}
            rounded={'lg'}
            w={6}
            h={6}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Icon as={InfoIcon} w={4} h={4} color={'brand.green'} />
          </Flex>
        </Flex>
      </PopoverTrigger>
      <PopoverContent width={{ base: '300px', sm: '400px' }} bg={'ninja.600'} border={'none'} rounded={'xl'}>
        <PopoverBody p={4}>
          <Text fontSize={'lg'} mb={1} fontWeight={700}>
            {t('common.randomness-number')}
          </Text>
          <Text fontSize={'sm'} mb={1} color={'ninja.100'}>
            {t('common.randomness-basis')}
          </Text>
          <Grid gridTemplateColumns={{ base: '1fr', sm: 'auto auto' }} gap={2}>
            <Box bg={'ninja.700'} rounded={'xl'} py={2} px={4}>
              <Text fontSize={'xs'} color={'ninja.100'} mb={0.5} fontWeight={700}>
                {t('common.randomness-id')}
              </Text>
              <Text color={'white'} fontSize={'sm'} fontWeight={'700'}>
                #{roundNumber}
              </Text>
            </Box>
            <Box bg={'ninja.700'} rounded={'xl'} py={2} px={4}>
              <Text fontSize={'xs'} color={'ninja.100'} mb={0.5} fontWeight={700}>
                {t('common.date')}
              </Text>
              <Text color={'white'} fontSize={'sm'} fontWeight={'700'}>
                {date}
              </Text>
            </Box>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
